import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import logo from "../../../../src/assets/forbidden-lands/forbidden-lands-logo.webp";
import sectionDivider from "../../../../src/assets/forbidden-lands/session16_17/bitter-reach-page-banner-session-16_17.webp";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./blade-runner-styles.scss";
import bladeRunnerLogo from "../../../../src/assets/blade-runner/logo-blade-runner.webp";

import synth from "../../../../src/assets/blade-runner/session04/synth-magazine.webp";

import cover from "../../../../src/assets/blade-runner/session05/blade-runner-session-05-cover.webp";
import gunfight from "../../../../src/assets/blade-runner/session05/marion-and-skinner-at-the-memory-lab.webp";
import lilith from "../../../../src/assets/blade-runner/session05/death-of-lilith.webp";
import baselineMachine from "../../../../src/assets/blade-runner/session04/baseline-test-machine.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, 0.7) ",
  color: "white",
  marginBottom: "15px",
};

const BRSession05 = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body, isLegend, caption) => {
    setModalData({
      body: body,
      image: img,
      isLegend: isLegend,
      caption: caption,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };

  const section1Data = [
    {
      title: "Last Clues (Day 3, Shift 3)",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={cover}
            caption="Mindkill"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Blade Runner Session 05: Mindkill. The detectives prepare to head to Lilith Tyrell's Memory Lab after receiving word of more unmarked assassins heading there."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The Safehouse yields its final secret: an old, sun-bleached postcard
          of the Hollywood Sign—now rumored to be nothing more than a rusted
          hulk sinking into the kipple-choked Hollywood Hills. A dead zone
          turned dumping ground, home only to edge-dwellers and illicit
          business. Whatever answers remain are waiting there.
          <br />
          <br />
          As the Blade Runners prepare to leave, Skinner’s street contact
          Grimski finally delivers. A shaky corner-boy vid arrives on Skinner’s
          KIA—grainy but unmistakable. An unmarked spinner, matching the profile
          of the assassins from yesterday, hovering over Lilith’s Memory Lab.
          The detectives divert immediately.
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Back to the Memory Lab",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          The Memory Lab Skinner and Marion arrive separately in their spinners,
          hovering a block out. Enhanced optics reveal trouble already underway:
          <ul>
            <li>
              An <strong>unmarked spinner</strong> parked out front
            </li>
            <li>
              <strong>Two armed soldiers</strong> guarding the entrance
            </li>
            <li>
              <strong>Two more at the side</strong>, one rappelling down a
              flexicord into a ventilation shaft while the other stands watch.
            </li>
          </ul>
          Their armor and loadout match the assassins who previously tried to
          kill them.
          <br />
          <br />
          The Blade Runners set down a street away. Skinner calls in backup as
          they sprint toward the side of the building. By the time they arrive,
          the guard is gone—but the flexicord still sways.
          <br />
          <br />
          Skinner descends first. Marion follows. They move through sub-floor
          access tunnels and emerge inside the Memory Dome just in time to hear
          chaos erupt.
          <br />
          <br />
          Lilith hisses at Sara to run and hide.
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Firefight in the Dome",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={gunfight}
            caption="Firefight in the Dome"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="Marion and Skinner at the Memory Lab under attack by hired soldiers while Lilith tries to protect Sara."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          Armed soldiers are already sweeping the lab.
          <br />
          <br />
          Marion opens fire, drawing attention as Lilith scrambles to take cover
          behind him. Skinner slips into the shadowed perimeter of the dome,
          searching for <strong>Sara</strong>.
          <br />
          <br />
          The firefight turns ugly fast. One soldier shrugs off hit after
          hit—armor rolls bordering on the impossible. A Terminator in human
          shape.
          <br />
          <br /> Skinner finds Sara and works to keep her calm as gunfire tears
          through the dome. <br />
          <br />
          Lilith is hit. Again. And again; the assassins clearly targeting only
          her. She breaks.
          <br />
          <br />
          Skinner signals toward the tunnels below—we’re getting out. They run.
          <br />
          <br />A single expert shot rings out from one of the faceless
          assassins. It punches clean through Lilith’s heart. She falls
          backward, instantly dead—her glassy eyes staring up into the abyss of
          the domed ceiling, beyond the reach of light. Lilith Tyrell no longer
          be making memories for Wallace Corporation.
          <br />
          <br />
          Marion and Skinner drag Sara clear as the remaining soldiers retreat
          to their spinner. By the time the Blade Runners reach the street, the
          hired guns are gone.
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
    {
      title: "Aftermath",
      text: (
        <div class="bladeRunnerFont bladeRunnerTitleText">
          <ImageComponent
            image={lilith}
            caption="Death of Lilith"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody="The death of Lilith Tyrell at the Memory Lab."
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent>
          The scene explodes into chaos. Forensics. Captains. Media drones.
          EMTs. Sirens everywhere.
          <br />
          <br />
          Skinner tells Sara to stay in his spinner across the street behind the
          lab. <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            "Where is my mom?"
          </font>
          <br />
          <br />
          Sara is calm but on the verge of tears.
          <br />
          <br />
          Marion:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            {" "}
            "She's ok Sara. She'll be with us later.
          </font>
          <br />
          <br />
          Skinner:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            Right now, I need you to get in my spinner. I need you to stay quiet
            and out of sight, just like your mom wanted ok?"
          </font>
          <br />
          Sergeant Reardon takes control, questioning both detectives on-site.
          During the confusion, Marion receives the promised call from Quell.
          <br />
          <br />
          Quell:{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “I told you I wanted an update by this evening. Now is the time.”
          </font>
          <br />
          <br />
          Marion tells the truth—mostly. They fought more hired assassins.
          Lilith is dead. Sara is gone. No idea where the child went. There’s a
          pause.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “What was the objective of the soldiers?”
          </font>{" "}
          Quell snaps.
          <br />
          <br />
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “To kill Lilith,”
          </font>{" "}
          Marion answers flatly.{" "}
          <font style={{ fontStyle: "italic", color: "yellow" }}>
            “Your star memory designer is gone.”
          </font>
          <br />
          <br />
          Quell curses. The call ends.
          <br />
          <br />
          <p>
            <a href="#pageTop">Back to Top</a>
          </p>
        </div>
      ),
    },
  ];

  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blade-runner/background-blade-runner-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "Orbitron",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={bladeRunnerLogo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Blade Runner campaign"
                  />
                </a>
              </main>

              <h1 className="cover-heading">MINDKILL</h1>
              <small>Blade Runner Session 05</small>

              {/* <p className="lead leadExtra">
                <BRSubNav />
              </p> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            {/* <img src={sectionDivider} alt="section divider" /> */}
            <Card.Body>
              <Card.Title
                id="cardTitle-blade-runner"
                className="cardTitle-blade-runner  "
              >
                <span
                  style={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  Skinner's street contact comes through with news of more
                  unmarked, professionals heading toward Lilith's Memory Lab.
                  Something bad is trying to happen.
                </span>
                <br />
                <font
                  style={{
                    color: "#C21E56",
                    textAlign: "center",
                    fontStyle: "italic",
                  }}
                >
                  WARNING: SPOILERS for Electric Dreams case file.{" "}
                </font>
                <br />
                <small>
                  ⇐ Session 04:{" "}
                  <a href="./blade-runner-session-04">Safehouse</a> ☠ Session
                  06: <a href="./blade-runner-session-06">Sign of the Times</a>{" "}
                  ⇒{" "}
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default BRSession05;
